<template>
	<div class="home">
		<UserInfo :formData="formData" />
		<TwoMod  :formData="formData" />
		<div class="items">
			<p class="form_title">
				跟单信息
			</p>
			<AboutView :formData="formData" />
		</div>
		<div class="items">
			<Acct :formData="formData"  />
		</div>
		<div class="items" v-if="formData.survey">
			<p class="form_title">
				勘测信息
			</p>
			<el-form label-width="120px" :model="formData"  ref="formRef">
				<!-- 勘测服务商 -->
				<el-form-item label="勘测服务商" prop="provider" >
					<el-col :span="18">
				
						<el-cascader v-model="formData.survey.providerId" 
						:options="providerTree" 
						:props="{emitPath: false, expandTrigger: 'click', value: 'id', label: 'name'}" 
						clearable filterable placeholder=""  @change="handleChangeKcs"/>
						
					</el-col>
					<!-- <el-col :span="6" style="text-align: right;">
						<el-button type="text" @click="reAssign">
							重新分配
						</el-button>
					</el-col> -->
				</el-form-item>
				<!-- 勘测人员 -->
				<el-form-item label="勘测人员" prop="surveyor" >
					<el-select v-model="formData.survey.engineerId"  class="input-small" placeholder="" filterable clearable @change="kcuser">
					  <el-option v-for="item in engineers" :key="item.id" :label="item.nickname" :value="item.id"  />
					</el-select>
				</el-form-item>
				
				<!-- 勘测总结 -->
				<el-form-item label="勘测总结" prop="summary" >
					<el-input v-model="formData.survey.summary" type="textarea" :rows="4" placeholder="请输入勘测总结"
					/>
				</el-form-item>
				
			</el-form>
		</div>
		<div class="btn_box">
			<el-button class="sub_btns" type="primary"  @click='savezongjie("0",formData.survey.summary)'>
				保存勘测总结
			</el-button>
		</div>
		
		<div class="items" v-if="formData.install">
			<p class="form_title">
				安装信息
			</p>
			<el-form label-width="120px" :model="formData"  ref="formRef">
				<!-- 勘测服务商 -->
				<el-form-item label="安装服务商" prop="provider" >
					<el-col :span="18">
					<!-- 	<el-select v-model="test_form.provider" placeholder="请选择安装服务商" style="width: 100%">
							<el-option label="测试大合集(测试部门X)" value="测试大合集(测试部门X)" />
							<el-option label="正式服务商A" value="正式服务商A" />
						</el-select> -->
						
						<el-cascader v-model="formData.install.providerId"
						:options="providerTree" 
						:props="{emitPath: false, expandTrigger: 'click', value: 'id', label: 'name'}" 
						clearable filterable placeholder=""  @change="installProvider"/>
					</el-col>
					
				</el-form-item>
				<!-- 勘测人员 -->
				<el-form-item label="安装人员" prop="surveyor" >
					
					<el-select v-model="formData.install.engineerId"  class="input-small" placeholder="" filterable clearable @change="kcuserinstall">
					  <el-option v-for="item in engineers" :key="item.id" :label="item.nickname" :value="item.id"  />
					</el-select>
				</el-form-item>
				
				<!-- 勘测总结 -->
				<el-form-item label="安装总结" prop="summary" >
					<el-input v-model="formData.install.summary" type="textarea" :rows="4" placeholder="请输入勘测总结"
					/>
				</el-form-item>
				
			</el-form>
			<div class="btn_box">
				<el-button class="sub_btns" type="primary" @click='savezongjie("1",formData.install.summary)'>
					保存安装总结
				</el-button>
			</div>
		</div>
		
	</div>
</template>
<script>
	// import { provinceAndCityData } from 'element-china-area-data'
import UserInfo from './UserInfo.vue'
import AboutView from './AboutView.vue'
import TwoMod from './two_module.vue'
import Acct from './acct.vue'
import request from '../utils/request'
import * as ww from '@wecom/jssdk'
export default {
	components: {
		UserInfo,
		AboutView,
		TwoMod,
		Acct
	},
	data() {
		// 常用正则
		const phoneReg = /^1[3-9]\d{9}$/
		const emailReg = /^[\w.-]+@[\w.-]+\.\w+$/
		const idcardReg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/

		return {
			providerTree:[],
			cityOptions: [{
				name: '北京市',
				code: '110000',
				children: [{
					name: '北京市',
					code: '110100',
					children: [{
						name: '东城区',
						code: '110101'
					},
					{
						name: '西城区',
						code: '110102'
					},
					]
				}]
			}],
			formData:{},
			
			
			
			
			test_form: {
				provider: '',
				surveyor: '',
				surveyDate: '',
				engineer: '',
				completeDate: '',
				summary: '',
				reportFile: null,
				reportPics: []
			},
			reportFileList: [],
			reportPicList: [],
			

		}
	},
	created() {
		// 
	
	},
	mounted() {
		this.getinit();
		
		 // setTimeout(() => {
		     
		 //    }, 3000); // 3000毫秒 = 3秒
		
	},
	methods: {
		savezongjie(row,summay){
			var data={};
			data.id =  this.formData.id;
			data.orderType =  row;
			data.summay =  summay;
			request.post('/applets/qywx/savesummary',data)
			.then(response => {
			   this.$message({
			            message: '保存成功',
			            type: 'success'
			          });
					
			   		// this.$router.go(0)
					
			   
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
			
			
		},
		handleChangeKcs(row){
			var data={};
			data.id =  this.formData.id;
			data.survey = {};
			data.survey.id =  this.formData.survey.id
			data.survey.providerId = row;
			request.post('/applets/qywx/dispatch_provider_survey',data)
			.then(response => {
			   this.$message({
			            message: '分配成功',
			            type: 'success'
			          });
					  this.formData.survey.engineerId = null;
			   		// this.$router.go(0)
				this.loadEngineers(row);	
			   
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
		},
		
		installProvider(row){
			var data={};
			data.id =  this.formData.id;
			data.install = {};
			data.install.id =  this.formData.install.id
			data.install.providerId = row;
			request.post('/applets/qywx/dispatch_provider_install',data)
			.then(response => {
			   this.$message({
			            message: '分配成功',
			            type: 'success'
			          });
					  this.formData.install.engineerId = null;
			   		// this.$router.go(0)
				this.loadEngineers(row);	
			   
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
		},
		
		/**
		 * 获取工程师列表
		 */
		loadEngineers(providerId) {
		  this.engineers = null
		   this.$forceUpdate();
		  request.get('/applets/qywx/engineers?providerId='+providerId)
		  .then(response => {
		     this.engineers = response.data
			 this.$forceUpdate();
		  })
		  .catch(error => {
		    console.error('请求失败:', error)
		    return null // 返回默认值，避免链式调用中断
		  })
		 
		},
		
		
		getproviderTree(){
			// 假设是GET请求，使用params传递参数
			const res = request.get('/applets/qywx/tree/adcode?adcode='+this.formData.cust.adcode+'&excludeBuiltIn=1')
			.then(response => {
			   this.providerTree = response.data;
			   if(this.formData.survey.providerId){
				   this.loadEngineers(this.formData.survey.providerId);
			   }
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
				
		},
		
		
		getinit(){
			console.log("进入初始化");
			const currentUrl = window.location.href.split('#')[0];
			if (this.isInWeCom()) {
				try {
					console.log('进入');
					// 注册SDK - 修正版本
					ww.register({
						corpId: 'ww0315322a5ec518c6',
						agentId: '1000005',
						jsApiList: ["checkJsApi", "getContext", "getCurExternalChat", "getCurExternalContact",
							"openDefaultBrowser", "wwapp.getOpenData", "wwapp.initWwOpenData",
							"getexternalchat","getUserInfo"
						],
						getConfigSignature: (url, nonceStr, timestamp) => {
							// 调用后端 API 获取签名
							return this.getConfigSignatures(url, nonceStr, timestamp);
						},
						getAgentConfigSignature: (url, nonceStr, timestamp) => {
							// 调用后端 API 获取签名
							return this.getAgentConfigSignatures(url, nonceStr, timestamp);
						}
					});
					 this.getGroupId();
						// 注册成功后获取上下文
						// this.getGroupId();
				} catch (err) {
					console.error('JSSDK初始化失败', err);
					// 输出更详细的错误信息
					console.error('错误名称:', err.name);
					console.error('错误信息:', err.message);
					console.error('错误堆栈:', err.stack);
				}
				}
		},
		getGroupId()  {
			console.log("进入一次");
			 const self = this;
			try {
				ww.getCurExternalChat({
					success(result) {
						// 成功回调，result.errMsg 固定格式为“方法名:ok”
						
						
						self.getUserInfo(result.chatId)
					},
					fail(result) {	// 失败回调，通过 result.errMsg 查看失败详情
						// alert(JSON.stringify(result))
					},
					complete(result) {
						// 完成回调，无论调用成功还是失败，都会回调该方法
					}
				})
			} catch (error) {
				console.error('获取群ID失败:', error)
				localMsg.value = '获取群ID失败' + JSON.stringify(error, null, 2)
			}
		},
		getUserInfo(row)  {
			
			console.log("进入一次");
			 const self = this;
			 try {
			      // 检查URL中是否有授权code
			      const urlParams = new URLSearchParams(window.location.search);
			      let code = urlParams.get('code');
			      
			      if (code) {
			        // 有code，直接换取用户信息
			        console.log('获取到授权code:', code);
			       this.getUserInfoByCode(code,row);
			      } else {
			        // 没有code，跳转到静默授权页面
			        console.log('未找到授权code，发起静默授权');
			        this.silentOAuthRedirect();
			      }
			    } catch (error) {
			      console.error('静默授权失败:', error);
			    }
		},
		
		getUserInfoByCode(code,row){
			console.log("进入两次");
			 const self = this;
		
			    // 假设是GET请求，使用params传递参数
			    const res = request.get('/applets/qywx/qyLogin?code='+code)
			    .then(response => {
			      localStorage.setItem('x-token', response.data)
				  	self.getDetail(row);
			      // 确保localMsg在当前作用域内已定义（解决潜在的问题2）
			      // if (localMsg && localMsg.value !== undefined) {
			      //   localMsg.value = response.data
			      // }
			    // this.getproviderTree();
			    })
			    .catch(error => {
			      console.error('请求失败:', error)
			      return null // 返回默认值，避免链式调用中断
			    })
			   
			
		},
	
	

		
		 // 静默授权跳转
		  silentOAuthRedirect() {
		    const corpId = 'ww0315322a5ec518c6'; // 你的企业ID
		    const agentId = '1000005'; // 你的应用ID
		    const redirectUri = encodeURIComponent(window.location.href.split('?')[0]);
		    
		    // snsapi_base：静默授权，不弹出授权页面
		    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE&agentid=${agentId}#wechat_redirect`;
		    
		    console.log('跳转到授权URL:', authUrl);
		    window.location.href = authUrl;
		  },
		
		 getDetail(chatId){
			 
			// 假设是GET请求，使用params传递参数
			const res = request.get('/applets/qywx/getchatIdByDetail?chatId='+chatId)
			.then(response => {
			  console.log('请求成功:', response.data)
			  this.formData = response.data;
			  // 确保localMsg在当前作用域内已定义（解决潜在的问题2）
			  // if (localMsg && localMsg.value !== undefined) {
			  //   localMsg.value = response.data
			  // }
			this.getproviderTree();
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
			
		},
		// 调用后端 API 获取签名
		async  getConfigSignatures(url, nonceStr, timestamp) {
			debugger
			const datas = {
				url
			}
			const res = await request.post('/applets/qywx/hello', datas)
			return res.data; // 返回签名
		},
		
		async getAgentConfigSignatures(url, nonceStr, timestamp) {
			debugger
			const datas = {
				url
			}
			const res = await request.post('/applets/qywx/yyid', datas)
			// const data = await res.data.json();
			return res.data; // 返回签名
		},
		// 1. 判断是否在企业微信环境
		 isInWeCom(){
			// 更严谨的判断方式
			return /wxwork/i.test(navigator.userAgent)
		},
		reAssign() {
			this.$message.info('重新分配功能待开发')
		},
		handleReportChange(file, fileList) {
			this.test_form.reportFile = file.raw 
			this.reportFileList = fileList.slice(-1)
		},
		handlePicChange(file, fileList) {
			this.test_form.reportPics = fileList.map(f => f.raw) 
			this.reportPicList = fileList
		},
		submitForm() {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					this.$message.success('表单校验通过，可继续提交后端')
					// TODO：调用接口保存数据
					console.log('提交数据', this.user_form)
				} else {
					this.$message.error('请完善表单信息') 
					return false
				}
			})
		},
		kcuser(row){
			var data={};
			data.id =  this.formData.id;
			data.survey = {};
			data.survey.id =  this.formData.survey.id
			data.survey.engineerId = row;
			request.post('/applets/qywx/dispatch_engineer_survey',data)
			.then(response => {
			   this.$message({
			            message: '分配成功',
			            type: 'success'
			          });
			   		// this.$router.go(0)
			   
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
		},
		kcuserinstall(row){
			var data={};
			data.id =  this.formData.id;
			data.install = {};
			data.install.id =  this.formData.install.id
			data.install.engineerId = row;
			request.post('/applets/qywx/dispatch_engineer_install',data)
			.then(response => {
			   this.$message({
			            message: '分配成功',
			            type: 'success'
			          });
			   		// this.$router.go(0)
			   
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
		},
		resetForm() {
			this.$refs.formRef.resetFields()
			this.user_form.satisfaction = 5;
		}
	}
}
</script>
<style lang="scss">
	* {
		margin: 0;
		padding: 0;
		list-style: none;
		text-decoration: none;
	}

	.home {
		text-align: center; padding: 0 0 40px; 
	} 
	.items{ 
		padding: 10px 20px;
		.form_title {
			font-size: 18px;
			margin-bottom: 10px;
			text-align: left;
		}
	}

	.btn_box {
		text-align: center;
	}
</style>